import { CustomModal } from '@/components/Molecules';
import React, { useEffect, useState } from 'react';
import api from '@/api/services/achievements';
import { formatNumberDecimals, numberSeparator } from '@/utils/numberSeparator';
import LoadingBalls from '@/components/Common/LoadingBalls';
import { useResponsive } from '@/hooks';
import styles from './LeaderBoardSection.module.scss';
import { useTranslate } from '@tolgee/react';
import { Typography } from '@/components/Atoms';
import ItemBoxAssetLeaderboard from './ItemBoxAssetLeaderboard';

export enum ELeaderBoardTabActiveProps {
  last = 'Recent Winners',
  max = 'Weekly Winners',
  most = 'Rankings',
}

interface LeaderBoardModalProps {
  leaderboardData: any;
  visible?: boolean;
  isLoading?: boolean;
  onClose: () => void;
  initTab?: ELeaderBoardTabActiveProps;
}

const LeaderBoardModal: React.FC<LeaderBoardModalProps> = ({ initTab, leaderboardData, visible, isLoading, onClose }) => {
  const { t } = useTranslate('commandCenter');
  const [leaderBoardTabActive, setLeaderBoardTabActive] = useState<ELeaderBoardTabActiveProps>(initTab);

  useEffect(() => {
    if (visible) {
      setLeaderBoardTabActive(initTab);
    }
  }, [visible]);

  const renderTabContent = () => {
    // Select the correct data based on the active tab
    const { records, user_position } =
      leaderboardData[
        leaderBoardTabActive === ELeaderBoardTabActiveProps.last
          ? 'recentWinners'
          : leaderBoardTabActive === ELeaderBoardTabActiveProps.max
          ? 'topLrtWinners'
          : 'topActiveUsers'
      ];

    return (
      <div className='flex flex-col gap-2 justify-between w-full'>
        <ItemBoxAssetLeaderboard
          list={records.map(({ leaderboard, position }) => ({
            username: leaderboard.username,
            value:
              leaderBoardTabActive === ELeaderBoardTabActiveProps.max
                ? `${numberSeparator(formatNumberDecimals(leaderboard.total_value || 0))}`
                : leaderBoardTabActive === ELeaderBoardTabActiveProps.most
                ? `${numberSeparator(leaderboard.TotalXp || 0)}`
                : leaderboard.name || '',
            position: position,
            level: leaderboard.Rank || '',
            badgeImg: leaderboard.Badge || '',
            rewardType: leaderBoardTabActive === ELeaderBoardTabActiveProps.max ? 'LRT' : 'XP',
          }))}
          lastCol={
            leaderBoardTabActive === ELeaderBoardTabActiveProps.max || leaderBoardTabActive === ELeaderBoardTabActiveProps.most ? 'Amount' : ''
          }
          isRecent={leaderBoardTabActive === ELeaderBoardTabActiveProps.last}
          myRankData={user_position !== -1 ? records.find((item) => item.position === user_position) : undefined}
        />
      </div>
    );
  };

  return (
    <CustomModal
      onClose={onClose}
      visible={visible}
      centered
      contentStyle={{
        width: '600px',
      }}
      // contentStyle={{
      //   width: !isTablet ? '600px' : '350px',
      // }}
      // bodyStyle={{
      //   height: '500px',
      // }}
    >
      <Typography size='s22ToS16' className='text-white mb-2' isBold>
        {t('RIGHT_SECTION.specialCommandSectionTop.leaderbord')}
      </Typography>
      <div className='flex mt-2 sm:gap-2 justify-between text-center sm:min-w-[400px]'>
        {Object.values(ELeaderBoardTabActiveProps).map((tab) => (
          <Typography
            key={tab}
            size='s16ToS14'
            className={`flex justify-center items-center w-full cursor-pointer sm:px-1 transition-all ${
              leaderBoardTabActive === tab ? 'text-[#00d0ab] border-b-[1px] pb-1 border-b-[#00D0AB]' : 'text-[#979797]'
            } hover:text-[#00d0ab] hover:border-b-[1px] hover:border-b-[#00D0AB]`}
            onClick={() => setLeaderBoardTabActive(tab)}
          >
            {tab}
          </Typography>
        ))}
      </div>
      <div className='w-full h-[1px] bg-[#9B9B9B] mt-[1px] mb-1'></div>
      {isLoading ? <LoadingBalls /> : <div className={styles.boxItems}>{renderTabContent()}</div>}
    </CustomModal>
  );
};

export default LeaderBoardModal;
